import React from 'react';
import PropTypes from 'prop-types';
import {Table, Button} from 'semantic-ui-react';
import moment from 'moment';
const NewAccountRequests = ({items, onOpen}) => {
    return (
        (items && items.length > 0 ?
        <Table celled>
            <Table.Header fullWidth>
                <Table.Row>
                    <Table.HeaderCell>Actions</Table.HeaderCell>
                    <Table.HeaderCell>Request Date</Table.HeaderCell>
                    <Table.HeaderCell>Policy Number</Table.HeaderCell>
                    <Table.HeaderCell>Policyholder</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {items && items.length ?
                items.map((item, key) =>
                    <Table.Row key={key}>
                        <Table.Cell>
                            <Button icon="eye" data={item} onClick={onOpen} />                            
                        </Table.Cell>
                        <Table.Cell>{moment(item.timeStamp).format('LL')}</Table.Cell>
                        <Table.Cell>{item.policyNumber}</Table.Cell>
                        <Table.Cell>{item.policyHolder}</Table.Cell>
                    </Table.Row>) : null}
            </Table.Body>            
        </Table>
        : <div>No pending verifications available</div>)
    );
};

NewAccountRequests.propTypes = {
    items: PropTypes.array,    
    onOpen: PropTypes.func.isRequired,        
};

export default NewAccountRequests;